namespace RecordShield.Workspace {
    export interface ProductItems2Row {
        Id?: number;
        Name?: string;
        MimeType?: string;
        Length?: number;
        Size?: number;
        SortOrder?: number;
        Extension?: string;
        ProductId?: number;
        CustomerKey?: number;
        ContentKey?: number;
        Sync?: boolean;
        RequestedForDelete?: boolean;
        SyncDate?: string;
        Code?: number;
        ContentTypeId?: number;
        EncryptionKeyId?: number;
        EncryptedName?: string;
        IsActive?: number;
        EncryptionPath?: string;
        TenantId?: number;
        ProductCode?: number;
        ProductName?: string;
        ProductDescription?: string;
        ProductUserId?: number;
        ProductViews?: number;
        ProductWatchTime?: number;
        ProductValidityInDays?: number;
        ProductUpdateFrequencyInDays?: number;
        ProductAllowSecondScreen?: boolean;
        ProductInsertDate?: string;
        ProductInsertUserId?: number;
        ProductUpdateDate?: string;
        ProductUpdateUserId?: number;
        ProductIsActive?: number;
        ProductCustomerKey?: number;
        ProductAuthorName?: string;
        ProductAuthorPhoto?: string;
        ProductAuthorDescription?: string;
        ProductEncryptionPath?: string;
        ProductEViews?: number;
        ProductEWatchTime?: number;
        ProductEValidity?: number;
        ProductTenantId?: number;
        ProductSupportInfo?: string;
        ProductTotalAllowedDuration?: number;
        ProductAllowedDevices?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace ProductItems2Row {
        export const idProperty = 'Id';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Workspace.ProductItems2';

        export namespace Fields {
            export declare const Id: string;
            export declare const Name: string;
            export declare const MimeType: string;
            export declare const Length: string;
            export declare const Size: string;
            export declare const SortOrder: string;
            export declare const Extension: string;
            export declare const ProductId: string;
            export declare const CustomerKey: string;
            export declare const ContentKey: string;
            export declare const Sync: string;
            export declare const RequestedForDelete: string;
            export declare const SyncDate: string;
            export declare const Code: string;
            export declare const ContentTypeId: string;
            export declare const EncryptionKeyId: string;
            export declare const EncryptedName: string;
            export declare const IsActive: string;
            export declare const EncryptionPath: string;
            export declare const TenantId: string;
            export declare const ProductCode: string;
            export declare const ProductName: string;
            export declare const ProductDescription: string;
            export declare const ProductUserId: string;
            export declare const ProductViews: string;
            export declare const ProductWatchTime: string;
            export declare const ProductValidityInDays: string;
            export declare const ProductUpdateFrequencyInDays: string;
            export declare const ProductAllowSecondScreen: string;
            export declare const ProductInsertDate: string;
            export declare const ProductInsertUserId: string;
            export declare const ProductUpdateDate: string;
            export declare const ProductUpdateUserId: string;
            export declare const ProductIsActive: string;
            export declare const ProductCustomerKey: string;
            export declare const ProductAuthorName: string;
            export declare const ProductAuthorPhoto: string;
            export declare const ProductAuthorDescription: string;
            export declare const ProductEncryptionPath: string;
            export declare const ProductEViews: string;
            export declare const ProductEWatchTime: string;
            export declare const ProductEValidity: string;
            export declare const ProductTenantId: string;
            export declare const ProductSupportInfo: string;
            export declare const ProductTotalAllowedDuration: string;
            export declare const ProductAllowedDevices: string;
            export declare const InsertUserId: string;
            export declare const InsertDate: string;
            export declare const UpdateUserId: string;
            export declare const UpdateDate: string;
        }

        ['Id', 'Name', 'MimeType', 'Length', 'Size', 'SortOrder', 'Extension', 'ProductId', 'CustomerKey', 'ContentKey', 'Sync', 'RequestedForDelete', 'SyncDate', 'Code', 'ContentTypeId', 'EncryptionKeyId', 'EncryptedName', 'IsActive', 'EncryptionPath', 'TenantId', 'ProductCode', 'ProductName', 'ProductDescription', 'ProductUserId', 'ProductViews', 'ProductWatchTime', 'ProductValidityInDays', 'ProductUpdateFrequencyInDays', 'ProductAllowSecondScreen', 'ProductInsertDate', 'ProductInsertUserId', 'ProductUpdateDate', 'ProductUpdateUserId', 'ProductIsActive', 'ProductCustomerKey', 'ProductAuthorName', 'ProductAuthorPhoto', 'ProductAuthorDescription', 'ProductEncryptionPath', 'ProductEViews', 'ProductEWatchTime', 'ProductEValidity', 'ProductTenantId', 'ProductSupportInfo', 'ProductTotalAllowedDuration', 'ProductAllowedDevices', 'InsertUserId', 'InsertDate', 'UpdateUserId', 'UpdateDate'].forEach(x => (<any>Fields)[x] = x);
    }
}
